<template>
  <div id="app">
    <AnchorNavbarPublic v-if="!hasAuthenticatedUser"/>
    <AnchorNavbarAuth v-else/>
    <b-container
      fluid
      :class="`${getRouterViewClass} ${getTeamMemberNotificationClass}`">
      <AnchorSidebar v-if="hasAuthenticatedUser && !hasTeamsAreaRequired" />
      <router-view/>
    </b-container>
    <notifications
      :duration="5000"
      group="alert"
      position="top center"
    />
    <ui-blocker />
  </div>
</template>

<script>
import { ENABLE_GOOGLE_API, DISABLE_GOOGLE_API, RECOVER_DATA, DEFINE_CAMPAIGN_URL } from '@/vuex/types/actions';
import AnchorNavbarPublic from '@/components/base/navbar/AnchorNavbarPublic';
import AnchorSidebar from '@/components/base/sidebar/AnchorSidebar';
import AnchorNavbarAuth from '@/components/base/navbar/AnchorNavbarAuth';
import AnchorFooter from '@/components/base/footer/AnchorFooter';
import UiBlocker from '@/components/utils/UiBlocker';
import VueIdentifyNetwork from 'vue-identify-network';

export default {
  name: 'App',
  components: {
    AnchorNavbarPublic,
    AnchorNavbarAuth,
    AnchorSidebar,
    AnchorFooter,
    UiBlocker,
    VueIdentifyNetwork,
  },
  created() {
    window.gm_authFailure = () => { this.$store.dispatch(DISABLE_GOOGLE_API); };
    this.$store.dispatch(ENABLE_GOOGLE_API);
    this.$store.dispatch(RECOVER_DATA);
    this.saveCampaignUrl();
  },
  computed: {
    hasAuthenticatedUser() {
      return this.$store.getters.hasAuthenticatedUser;
    },
    hasTeamsAreaRequired() {
      return this.$store.getters.hasTeamsAreaRequired;
    },
    getRouterViewClass() {
      if (this.hasAuthenticatedUser && this.$route.name !== 'TeamsArea') {
        return 'main-container main-container-authenticated-user';
      }

      return 'main-container';
    },
    getTeamMemberNotificationClass() {
      const user = this.$store.getters.user;
      const profile = this.$store.getters.profile;
      if (profile && user) {
        if (profile.contact.email !== user.email) {
          return 'team-member';
        }
      }
      return '';
    },
  },
  methods: {
    saveCampaignUrl() {
      const url = window.location.href;
      if (url.includes('campaign') || url.includes('ad')) {
        const campaignUrl = url.substring(url.lastIndexOf('?') + 1, url.lastIndexOf('#'));
        this.$store.dispatch(DEFINE_CAMPAIGN_URL, campaignUrl);
      }
    },
  },
};
</script>

<style>
html,body{
  min-height: 100vh;
}
body {
  padding-top: 68px;
}

#app{
  --app-sidebar-width: 350px;
  min-height: calc(100vh - 68px);
}


body :has(.auth__login-page, .anchor-sidebar) {
  background-color: #f5f5f5;
}

body :has(.auth__login-page,.auth__register-page) {
  padding-top: 0;
}

header.spaced-header {
  margin: 0px -15px 45px -15px !important;
  padding-bottom: 30px;
  padding-top: 42px;
  color: #6f6f6f;
}

header.spaced-header .header-link {
  color: black;
}

.background-cover {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}

.main-container {
  min-height: calc(100vh - 68px);
}

.text-light-blue {
  color: rgb(62, 136, 201);
}

.text-light-gray {
  color: #c6c6c6;
}

.text-gray {
  color: #212020;
}

.text-anchor {
  color: #3e88c9 !important;
}

.border-anchor {
  border-color: #3e88c9;
}

.text-danger {
  color: #a94442 !important;
}

.text-light-danger {
  color: #e66d70;
}

.button-danger {
  background-color: #a94442;
}

.popover.bs-popover-bottom .arrow::after {
  border-bottom-color: #3e88c9;
}

.popover.bs-popover-left .arrow::after {
  border-left-color: #3e88c9;
}

.popover-header {
  background-color: #3e88c9;
  color: white;
}

.bg-anchor {
  background-color: #3e88c9;
  color: white;
}

.bg-anchor a, .bg-anchor a:hover, .bg-anchor a:focus {
  color: #343a40 !important;
}

.btn-anchor {
  background-color: #3e88c9;
  border-color: #30799c;
  color: white !important;
  font-size: 14pt;
  font-weight: bold;
}

.btn-anchor:hover, btn-anchor:active {
  color: #fff;
  background-color: #2674b7;
  border-color: #1f639e;
}

.btn-outline-anchor {
  color: #2d6a9f;
  border-color: #2d6a9f;
}

.btn-outline-anchor:hover {
  color: #fff;
  background-color: #2674b7;
  border-color: #1f639e;
}

.btn-success {
  background-color: #29932d !important;
  border-color: #29932d !important;
}

.btn-success:hover {
  background-color: #29932d !important;
  border-color: #29932d !important;
}

.errors {
  color: #a94442 !important;
}

.anchor-navbar .navbar-nav .dropdown-menu {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  font-size: .9rem;
  margin-top: 12px !important;
  padding: 0;
}

.anchor-navbar .navbar-nav .dropdown-menu .dropdown-item.active,
.anchor-navbar .navbar-nav .dropdown-menu .dropdown-item:active {
    background-color: #3e88c9 !important;
}

.vue-notification {
  padding: 10px !important;
  margin: 75px 5px 5px !important;
  font-size: 16px !important;
  text-align: center !important;

  color: #ffffff;
  background: #44A4FC;
  border-bottom: 5px solid #187FE7;
  border-left: none;
}

.vue-notification.warn {
  background: #ffb648;
  border-bottom-color: #f48a06;
}

.vue-notification.error {
  background: #e54d42;
  border-bottom-color: #b82e24;
}

.vue-notification.success {
  background: #68CD86;
  border-bottom-color: #42A85F;
}


.invalid-input input,
.invalid-input select {
  border-color: #a94442 !important;
}

/*Used to customize checkbox */
.invalid-input ~ .custom-control-label::before {
  border-color: #a94442 !important;
}

.invalid-input select:focus,
.invalid-input input:focus {
  border-color: #dc3545;
  box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, .25);
}

.radio-list label {
  cursor: pointer;
}

.radio-container {
  text-align: center;
}

.radio-container .radio-list {
  display: flex;
  width: 100%;
}

.radio-container .radio-list label {
  text-align: center;
  margin: 0 auto;
}

.bool-radio .radio-list {
  display: -webkit-box;
  width: 100%;
}

.inline-radio .radio-list {
  width: 100%;
}

.bool-radio .radio-list label {
  width: 50%;
}

.full-width-upload .field-wrap .wrapper {
  width: 100% !important;
}

.form-submit-btn {
  color: #fff!important;
  background-color: #337ab7!important;
  border-color: #2e6da4!important;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
}

.form-submit-btn:hover {
  background-color: #18588e !important;
  border-color: #155c99 !important;
}

.submit-btn-container {
  display: grid;
  justify-items: end;
  justify-content: right;
  text-align: right;
}

.submit-btn-container .hint {
  margin-top: .5rem;
}

.submit-btn-container .field-wrap input {
  transition: color 0.15s ease-in-out,
              background-color 0.15s ease-in-out,
              border-color 0.15s ease-in-out,
              box-shadow 0.15s ease-in-out;
}

.submit-btn-container .field-wrap input:active,
.submit-btn-container .field-wrap input:focus {
  outline: 0 !important;
  box-shadow: 0 0 0 0.2rem rgba(24, 88, 142, 0.5) !important;
}

.submit-btn-container .field-wrap input:hover {
  background-color: #18588e !important;
  border-color: #155c99 !important;
}

.full-width {
  width: 100%;
}

.font-14p {
  font-size: 14px;
}

.transparent-bg {
  background-color: transparent;
}

.flex-center {
  display: flex;
  justify-content: center;
}

.wizard-navigation .wizard-progress-with-circle {
  margin-right: -15px !important;
  margin-left: -15px !important;
}

.wizard-navigation .wizard-nav .wizard-nav-pills {
  margin-right: -15px !important;
  margin-left: -15px !important;
}

button.swal2-styled {
  padding: 5px 12px !important;
  font-size: 14px !important;
}

button.swal2-confirm {
  background-color: #3e88c9 !important;
}

button.swal2-cancel {
  background-color: #545b62 !important;
}

.swal2-popup .swal2-title {
  font-size: 27px !important;
}

.swal2-popup #swal2-content {
  font-size: 16px !important;
}

.vue-form-wizard .wizard-btn {
  transition-duration: .3s;
}

.vue-form-wizard .wizard-btn.finish-button {
  background-color:#43A047 !important;
  border-color: #43A047 !important;
  -webkit-box-shadow: 5px 8px 17px 0 rgba(0,0,0,.2), 5px 6px 20px 0 rgba(0,0,0,.19);
  box-shadow: 5px 8px 17px 0 rgba(0,0,0,.2), 5px 6px 20px 0 rgba(0,0,0,.19);
}

.vue-form-wizard .wizard-btn.finish-button:hover {
  background-color: #29932d !important;
  border-color: #29932d !important;
}

.vue-form-wizard .wizard-btn.next-button {
  -webkit-box-shadow: 5px 8px 17px 0 rgba(0,0,0,.2), 5px 6px 20px 0 rgba(0,0,0,.19);
  box-shadow: 5px 8px 17px 0 rgba(0,0,0,.2), 5px 6px 20px 0 rgba(0,0,0,.19);
}

.vue-form-wizard .wizard-btn.next-button:hover {
  background-color: #2e7cc1 !important;
  border-color: #2e7cc1 !important;
}

.vue-form-wizard .wizard-btn.previous-button {
  color: #fff;
  background-color: #6c757d !important;
  border-color: #6c757d !important;
  -webkit-box-shadow: -5px 8px 17px 0 rgba(0,0,0,.2), -5px 6px 20px 0 rgba(0,0,0,.19);
  box-shadow: -5px 8px 17px 0 rgba(0,0,0,.2), -5px 6px 20px 0 rgba(0,0,0,.19);
}

.vue-form-wizard .wizard-btn.previous-button:hover {
  background-color: #565b60 !important;
  border-color: #565b60 !important;
}

.vue-form-generator .form-group.error .errors {
  font-size: initial !important;
}

.vue-form-generator .form-group.error input:not([type=checkbox]),
.vue-form-generator .form-group.error select,
.vue-form-generator .form-group.error textarea {
  border-color: #a94442 !important;
  background-color: white !important;
}

.vue-form-generator .form-group.error .errors span {
  font-weight: initial !important;
  background-image: none !important;
  padding: initial !important;
}


@media (max-width: 430px){
  .vue-form-wizard .wizard-btn {
    min-width: inherit;
  }
}

.inline-field {
  display: -webkit-box;
}

.inline-field .field-wrap {
  margin-left: 1rem;
}

.sidebar-sub-item {
  margin-left: 5px;
  border-left: 2px solid #1d87b9;
  padding-left: 5px;
  font-size: 14px;
}

.pac-container {
  z-index: 2000;
}

.datepicker-day {
  margin: 0 !important;
}

.nav-pills .nav-link {
  color: #3e88c9 !important;
}

.nav-pills .nav-link.active {
  background-color: #3e88c9 !important;
  border-color: #30799c !important;
  color: white !important;
  font-size: 14pt;
  font-weight: bold;
}

.progress-bar {
  background-color: #3e88c9 !important;
  border-color: #30799c !important;
  color: white !important;
}

.date-time-picker .field-input {
  height: 34px;
  min-height: 34px;
  line-height: 1.5rem;
  color: #555;
}

.date-time-picker .field-input:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}


.date-time-picker .field.has-value .field-label {
  opacity: 0;
}

.date-time-picker .field.has-value .field-input {
  padding-top: 2px !important;
}

.raised {
  -webkit-box-shadow: 0px 5px 5px 0 rgba(0,0,0,.2), 0px 5px 15px 0 rgba(0,0,0,.19);
  box-shadow: 0px 5px 5px 0 rgba(0,0,0,.2), 0px 5px 15px 0 rgba(0,0,0,.19);
}

button.raised {
  -webkit-box-shadow: 0px 3px 3px 0 rgba(0,0,0,.2), 0px 5px 15px 0 rgba(0,0,0,.19);
  box-shadow: 0px 3px 3px 0 rgba(0,0,0,.2), 0px 5px 15px 0 rgba(0,0,0,.19);
}

.raised-submit-btn .field-wrap input {
  -webkit-box-shadow: 0px 3px 3px 0 rgba(0,0,0,.2), 0px 3px 15px 0 rgba(0,0,0,.19);
  box-shadow: 0px 3px 3px 0 rgba(0,0,0,.2), 0px 3px 15px 0 rgba(0,0,0,.19);
}

.grid-display {
  display: grid;
}

.field-add-btn {
  height: 38px;
}

.anchor-modal {
  background-color: #3e88c9 !important;
  color: white !important;
}

.anchor-modal > button {
  color: white !important;
  opacity: 1;
}

.anchor-modal-close-button {
  color: white !important;
  opacity: 1;
  margin-top: -0.40rem !important;
}

.pointer-cursor {
  cursor: pointer;
}

.switch-pointer-cursor label {
  cursor: pointer;
}

.profile-tabs .card-header {
  background-color: #3e88c9;
}


.profile-tabs .card-header .nav-tabs li {
  text-align: center;
  margin: -1px auto;
}

.profile-tabs .card-header .nav-tabs .nav-link {
  background-color: transparent;
  border: 0px;
  color: #275d8b;
}

.profile-tabs .card-header .nav-tabs .nav-link.active {
  background-color: transparent;
  border-bottom: 3px solid #3e88c9;
  color: #2d6a9f;
}

.profile-tabs .card-header .nav-tabs .nav-link.active.errors {
  border-bottom: 3px solid #a94442;
  color: #a94442;
}

@media (min-width: 992px) {
  .modal-lg, .modal-xl {
      max-width: 800px;
  }
}

@media (min-width: 1200px) {
  .modal-xl {
      max-width: 1140px;
  }
}

.filter-field .field-wrap .wrapper input,
.filter-field .field-wrap .wrapper select {
  height: 38px !important;
}

.margin-auto-x {
  margin: 0 auto;
}

.radio-list label {
  position: relative;
  padding-left: 1.3rem;
}

.radio-list label.is-disabled {
  color: #6c757d;
}

.radio-list label::before {
  position: absolute;
  top: .2rem;
  left: 0;
  display: block;
  width: 1rem;
  height: 1rem;
  pointer-events: none;
  content: "";
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: #dee2e6;
  border-radius: 50%;
}

.radio-list label.is-disabled::before {
  border: #adb5bd solid 1px;
  background-color: #e9ecef;
}

.radio-list label.is-checked::before {
  color: #fff;
  background-color: #3e88c9;
}

.radio-list label::after {
  position: absolute;
  top: .2rem;
  left: 0;
  display: block;
  width: 1rem;
  height: 1rem;
  content: "";
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 50% 50%;
}

.radio-list label.is-checked::after {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3E%3Ccircle r='3' fill='%23fff'/%3E%3C/svg%3E");
}

.radio-list label input[type="radio"] {
  position: absolute;
  z-index: -1;
  opacity: 0;
}

.custom-radio .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #3e88c9;
}

.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
}

.bottom-border {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.fab-main-container {
  z-index: 2 !important;
}

.fab-menu-downwards .fab-item-container {
  transform: rotate(180deg);
}

.fab-menu-downwards .fab-item-container .fab-item {
  transform: rotate(180deg);
}

@media (min-width: 769px) {
  .left-border {
    border-left: 1px solid rgba(0, 0, 0, 0.1);
  }
}

@media (max-width: 768px) {
  .left-border {
    margin-top: 1rem;
  }
}

.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  background-color: #3e88c9;
}

.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #3e88c9;
}

.checkbox-pointer .custom-checkbox label {
  cursor: pointer;
}

.checkbox-pointer .custom-checkbox label::after {
  padding-right: 25px;
  background-position-x: 2px;
}

.text-small {
  font-size: small;
}

.text-large {
  font-size: large;
}

.vue-form-generator .field-switch input:checked~.label {
  background-color: #3e88c9;
}

.vue-form-generator .is-disabled input {
  color: #6c757d !important;
}

.relative-position {
  position: relative;
}

.text-lightblue {
  color: lightblue;
}

.login-form .form-group {
  margin-bottom: 0;
}

.inline-select-btn {
  font-size: 16px !important;
  line-height: 24px !important;
}

.inherit-min-height {
  min-height: inherit !important;
}

.table-yellow, .table-yellow > th, .table-yellow > td {
  background-color: #ffdf80;
}

.table-yellow:hover {
  background-color: #ffdb6b;
}

.field-array .field-wrap > div {
  width: 100% !important;
}

.phone-item-container {
  display: flex;
}

.phone-item-container > span {
  width: calc(100% - 60px);
}

.phone-item-container > input[type="button"] {
  margin-top: 2rem;
}

.remove-phone-btn {
  max-height: 35px;
}

.flex-container {
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
}

.btn-anchor-pressed {
  background-color: #05365e !important;
  border-color: #05365e !important;
}

.no-text-decoration, .no-text-decoration:hover, .no-text-decoration:active {
  text-decoration: none;
}

.ada-text-style {
    font-size: 14pt;
    font-weight: bold;
}

.dropdown-anchor button {
  background-color: #3e88c9;
  border-color: #30799c;
  color: white !important;
}

.dropdown-anchor button:hover, dropdown-anchor button:active,
.show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: #2674b7;
  border-color: #1f639e;
}


@media (max-width: 992px) {
  #app {
    --app-sidebar-width: 280px !important;
  }
}

@media (min-width: 768px) {
  .main-container.main-container-authenticated-user {
    padding-left: calc(var(--app-sidebar-width) + 1rem) !important;
  }

}

@media (max-width: 576px) {
  .main-container.team-member {
    padding-top: 19px;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue